import { Component, EventEmitter, inject, input, OnInit, Output } from "@angular/core";
import { FaIconLibrary, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import { TranslationComponent } from "../translation/translation";

@Component({
  selector: "adaa-note",
  imports: [FontAwesomeModule, TranslationComponent],
  templateUrl: "./note.html",
  styleUrl: "./note.scss",
})
export class NoteComponent implements OnInit {
  private _iconLibrary: FaIconLibrary = inject(FaIconLibrary);

  title = input.required<string>();
  message = input.required<string>();
  number = input<number | undefined | null>(undefined);
  subTitle = input<string | undefined | null>(undefined);
  isEditable = input<boolean>(false);
  translatedTextMap?: { [key: string]: string };

  @Output() removeClicked = new EventEmitter<void>();

  public ngOnInit(): void {
    this._iconLibrary.addIcons(faXmark);
  }

  public onTranslationDone(type: string, translated: string): void {
    if (!this.translatedTextMap) {
      this.translatedTextMap = {};
    }
    this.translatedTextMap[type] = translated;
  }
}
